import React, { useState, ComponentType, createContext } from 'react';

type AutocompletePrediction = google.maps.places.AutocompletePrediction;

interface LocationContextValue {
    value2: AutocompletePrediction | null;
    setValue2: React.Dispatch<React.SetStateAction<AutocompletePrediction | null>>;
}

interface ChildrenProps {
    children: React.ReactNode;
}

export const LocationContext = createContext<LocationContextValue | null>(null)

export const LocationProvider: ComponentType<ChildrenProps> = ({ children }) => {

    const [value2, setValue2] = useState<AutocompletePrediction | null>(null);

    return (
        <LocationContext.Provider value={{ value2, setValue2 }}>
            {children}
        </LocationContext.Provider>
    )
}